export enum tipoNivelUsuarioSeparados{
    Precio,
    Comercial,
    Refacturacion
}